<template>
  <div id="app">
    <app-header></app-header>
    <login ref="loginModule" :visible="showLogin"></login>
    <div class="main-container">
      <transition name="fade-transform" mode="out-in">
        <router-view/>
      </transition>
    </div>
    <app-footer class="footer"></app-footer>
  </div>
</template>

<script>
import AppHeader from "components/Header";
import AppFooter from "components/Footer";
import Login from '@/views/Login'
import {mapGetters} from 'vuex'
export default {
  components: {
    AppHeader,
    AppFooter,
    Login
  },
  computed: {
    ...mapGetters(['showLogin'])
  },
};
</script>

<style lang="scss">
#app {
  width: 100%;
  min-height: 100vh;
  position: relative;
  .main-container {
    padding-bottom: 100px;
  }
  .footer {
    height: 100px;
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue